// import CHIPS_KEYBOARD_NAV from "./_chips-keyboardnav.js";
import swiperSlideshow from "./components/swiperSlideshow.js";
import audioplayer from "./components/_audio.js";
import CHIPSMENU from "./components/_menu.js";
import inView from "in-view";

class App {
	constructor(options) {
		this.defaults = {};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "App";
		this.init();
	}

	init() {
		let appScope = this;
		this.scrollItems();
		this.initSwiperSliders();
		this.initAudioPlayers();
		this.readMoreEls();
		this.ivEls();
		this.vidCover();
		this.formUX();
		this.initMenu = new CHIPSMENU();
		this.walkingTour();
		this.audioModal();
		// this.modals();

		window.addEventListener("popstate", function (event) {
			let urlParams = new URLSearchParams(window.location.search);
			let tour = urlParams.get("stop");
			if (tour) {
				appScope.walkingTourHTML(tour);
			} else {
				appScope.walkingTourHTML(null);
			}
		});
	}

	initSwiperSliders() {
		let $swiper = $(".swiper");
		if ($swiper.length > 0) {
			$swiper.each((i, el) => {
				if ($($swiper).find(".swiper-slide").length > 1) {
					new swiperSlideshow({
						$el: $(el),
					});
				}
			});
		}
	}

	initAudioPlayers() {
		let $audios = $(".audio-player");
		if ($audios.length > 0) {
			$audios.each((i, el) => {
				new audioplayer({
					$el: $(el),
				});
			});
		}
	}

	readMoreEls() {
		$(".readmore-toggle").on("click", function () {
			$(this).closest(".wyg").addClass("read-on");
		});
	}

	formUX() {
		$(".gfield input").on("blur", function () {
			if ($(this).val() !== "") {
				$(this).closest(".gfield").addClass("el-filled");
			} else {
				$(this).closest(".gfield").removeClass("el-filled");
			}
		});
		$(".gfield textarea").on("blur", function () {
			if ($(this).val() !== "") {
				$(this).closest(".gfield").addClass("el-filled");
			} else {
				$(this).closest(".gfield").removeClass("el-filled");
			}
		});
		$(".gfield select").on("change", function () {
			if ($(this).val() !== "") {
				$(this).closest(".gfield").addClass("el-filled");
			} else {
				$(this).closest(".gfield").removeClass("el-filled");
			}
		});

		$(".gfield select").each(function () {
			$(this).parent().addClass("select-wrap");
		});

		$(".collection-filters select").on("change", function () {
			let newVal = $(this).val();
			// console.log(newVal);
			if (newVal === "") {
				window.location = "/collection/";
			} else {
				window.location = "/collection/?loc=" + newVal;
			}
		});

		if (
			$(".gform_wrapper").hasClass("gform_wrapper") &&
			typeof gform !== "undefined"
		) {
			gform.addFilter(
				"gform_square_card_details_style",
				function (styleObject, formId) {
					// if ( formId === myFormId ) {
					styleObject.input.backgroundColor = "#f9f9ed";
					styleObject.input.color = "#000000";
					// }
					return styleObject;
				}
			);
		}
	}

	ivEls() {
		let ivGen = document.querySelectorAll(".iv");
		if (ivGen && ivGen.length > 0) {
			inView(".iv").on("enter", (el) => {
				el.classList.add("vis");
			});
		}
	}

	vidCover() {
		$(".jpg-cover").on("click", function () {
			var iframe = $(this).parent().find("iframe");
			iframe.attr("src", iframe.attr("data-src"));
			$(this).addClass("interacted");
		});
	}

	audioModal() {
		$(".inline-audio-wrap .audio-label").on("click", function (e) {
			e.preventDefault();
			let audioSrc = $(this).parent().find("textarea").val();
			$(".audio-modal .modal-content").html(audioSrc);
			$("body").addClass("audio-on");
			// console.log(audioSrc);
		});

		$(".audio-modal .modal-close, .audio-modal .modal-bg").on(
			"click",
			function (e) {
				e.preventDefault();
				$(".audio-modal .modal-content").html("");
				$("body").removeClass("audio-on");
			}
		);
	}

	modals() {}

	walkingTour() {
		let appScope = this;

		let urlParams = new URLSearchParams(window.location.search);
		let tour = urlParams.get("stop");
		if (tour && tour !== "null") {
			$("body").removeClass("walking-tour-intro");
			$("body").addClass("walking-tour-interior");
		} else {
			$("body").addClass("walking-tour-intro");
			$("body").removeClass("walking-tour-interior");
		}
		$(".walking-tour-nav li")
			.not("[data-stop='" + tour + "']")
			.removeClass("active");
		$(".walking-tour-nav a, .tour-begin").on("click", function (e) {
			e.preventDefault();
			let $this = $(this);
			let $target = $(this).attr("href");

			let newStop = $(this).data("stop");
			appScope.walkingTourHTML(newStop);
			// $("html, body").animate({ scrollTop: 0 }, 500);
			window.scrollTo({ top: 0, behavior: "smooth" });
		});
		$(".walking-tour-nav a").on("click", function (e) {
			e.preventDefault();
			let $this = $(this);
			let $par = $(this).parent();
			let $target = $(this).attr("href");

			// vanilla js scroll to horizontal offset of this element
			// document.querySelector($this).scrollIntoView({
			// 	behavior: "smooth",
			// 	block: "start",
			// 	inline: "start",
			// });
			// e.target.parentNode.scrollLeft = e.target.offsetLeft;
			// $(".walking-tour-nav-wrap").scrollTo(e.target.offsetLeft);
			// scroll div horizontally
			let newLeft =
				$(".walking-tour-nav-wrap").scrollLeft() +
				$par.offset().left -
				20;
			// console.log($par.offset().left);
			// get full width of device
			$(".walking-tour-nav-wrap").scrollLeft(newLeft);
		});
	}

	walkingTourHTML(stop) {
		let appScope = this;
		// $("#stopwrap, body").addClass("transitioning");
		let ajURL = "?";
		if (stop && stop !== "intro") {
			ajURL = "?stop=" + stop;
		}

		$.ajax({
			url: ajURL,
			success: function (data) {
				$("#stopwrap").html($(data).find("#stopwrap").html());
				$(".walking-tour-nav").html(
					$(data).find(".walking-tour-nav").html()
				);
				if (stop && stop !== "null") {
					let urlParams = new URLSearchParams(window.location.search);
					let tour = urlParams.get("stop");
					if (tour !== stop) {
						history.pushState(null, null, "?stop=" + stop);
					}
				}
				setTimeout(function () {
					appScope.walkingTour();
				}, 150);
				// $(".transitioning").removeClass("transitioning");
			},
		});
	}

	scrollItems() {
		let scrollPosOld = 0;
		let scrollPosNew = 0;
		let scrollDelta = 0;
		let scrollThreshold = 20;
		let scrollDown = false;

		window.addEventListener("scroll", (e) => {
			scrollPosNew = window.pageYOffset;
			let distanceTraveled = scrollDelta - scrollPosNew;
			// if (window.pageYOffset > 60) {
			// 	$("header.site-header").addClass("scroll");
			// } else {
			// 	$("header.site-header").removeClass("scroll");
			// }
			// if (window.pageYOffset > 500) {
			// 	if (distanceTraveled <= -1 * scrollThreshold) {
			// 		// console.log("Down");
			// 		scrollDelta = scrollPosNew;
			// 		scrollDown = true;
			// 		$("header").removeClass("scrollup");
			// 	} else if (distanceTraveled >= scrollThreshold) {
			// 		// console.log("Up");
			// 		scrollDelta = scrollPosNew;
			// 		scrollDown = false;
			// 		$("header").addClass("scrollup");
			// 	}
			// } else {
			// 	scrollDelta = scrollPosNew;
			// 	scrollDown = false;
			// 	$("header").removeClass("scrollup");
			// }

			scrollPosOld = scrollPosNew;
		});
	}
}

const app = new App();

$(document).on("keyup", function (e) {
	if (e.keyCode === 192) {
		$(".grid-overlay").toggleClass("shown");
	}
	if (e.keyCode === 221) {
		$("body").toggleClass("gal-only");
	}

	if (e.keyCode === 27) {
		$("body").removeClass("menu-on");
		$("body").removeClass("modal-on");
	}
	// console.log(e.keyCode);
});

$(".hovParent a:not(.pill-link)").on({
	mouseenter: function () {
		$(this).closest(".hovParent").addClass("hovered");
	},
	mouseleave: function () {
		$(this).closest(".hovParent").removeClass("hovered");
	},
});

$(".hovParentShared a.hovTarget").on({
	mouseenter: function () {
		$(this).closest(".hovParentShared").addClass("hovered");
	},
	mouseleave: function () {
		$(this).closest(".hovParentShared").removeClass("hovered");
	},
});

// import CHIPSAJ from "./_chips-aj.js";
// import CHIPSSLIDER from "./components/_chips-slider.js";

// class App {
// 	constructor(options) {
// 		this.defaults = {};
// 		this.options = {};
// 		Object.assign(this.options, this.defaults, options);

// 		this.namespace = "App";
// 		this.init();
// 	}

// 	init() {
// 		/* DO something on load */
// 		this.sliders = new CHIPSSLIDER();
// 		this.initMenu = new CHIPSMENU();
// 	}
// }

// const app = new App();

/* TEMP STUFF */
// Grid on/off
$(document).on("keyup", function (e) {
	if (e.keyCode === 192) {
		$(".grid-overlay").toggleClass("hidden");
	}
});




